{
  "version": 1,
  "asset_id": "59802b01-8e4b-4f05-97b4-d64c4e226046",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/59802b01-8e4b-4f05-97b4-d64c4e226046/author-naomi-bootman.webp",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/59802b01-8e4b-4f05-97b4-d64c4e226046/author-naomi-bootman.webp",
  "original_filename": "author-naomi-bootman.webp",
  "size": 46954,
  "content_type": "image/webp",
  "created_at": "2026-08-30T14:14:52Z"
}
